import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aciair/acr'
import pathMap from 'src/paths/pathMap'

class AciAirRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACI_AIR_ACR_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACI_AIR_ACR_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACI_AIR_ACR_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACI_AIR_ACR_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AciAirRoute
